// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1f6En","fileBtn":"File_fileBtn__10mfU","closeBtn":"File_closeBtn__1da9R","fileSelected":"File_fileSelected__2-PBZ","disabled":"File_disabled__3UqFw"};